import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useQuery } from 'react-query';
import FormDatiPrincipaliUtente from '../../../../components/FormDatiPrincipaliUtenti';
import { regions } from '../../../../api/regions';

const NuovoUtenteAnagrafica = () => {
  const { watch, control, setValue, resetField } = useFormContext();
  const { data: regionsData } = useQuery('regions', regions);
  const esteroRegionId = regionsData?.data.find(
    (region) => region.attributes.code === 'EST'
  )?.id;

  // Logica per cambiare le select di Nazione, regione e provincia

  useEffect(() => {
    const region = watch('region');
    if (region !== undefined && region !== esteroRegionId) {
      setValue('nation', 1);
    }
  }, [watch('region', 'province'), esteroRegionId]);

  useEffect(() => {
    resetField('province');
  }, [watch('region')]);

  useEffect(() => {
    if (watch('nation') !== 1) {
      resetField('province');
      resetField('region');
    }
  }, [watch('nation')]);

  // Logica per cambiare le select di Nazione, regione e provincia di HomeAddress
  useEffect(() => {
    const region = watch('homeAddress.region');
    if (region !== undefined && region !== esteroRegionId) {
      setValue('homeAddress.nation', 1);
    }
  }, [watch('homeAddress.region', 'homeAddress.province'), esteroRegionId]);

  useEffect(() => {
    resetField('homeAddress.province');
  }, [watch('homeAddress.region')]);

  useEffect(() => {
    if (watch('homeAddress.nation') !== 1) {
      resetField('homeAddress.province');
      resetField('homeAddress.region');
    }
  }, [watch('homeAddress.nation')]);

  return (
    <div className='pb-28'>
      <FormDatiPrincipaliUtente creationForm/>
    </div>
  );
};

export default NuovoUtenteAnagrafica;
